import { BookingStatus } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export interface BookingContainerInput {
  containerTypeId: string;
  quantity: number;
}

export interface PhotoRequirementInput {
  description: string;
  required: boolean;
}

export const bookingCreateAtom = createMutationAtomFactory(
  'trade.bookingCreate',
  (params: {
    facilityId: string;
    documentNumber: string;
    status: BookingStatus;
    containers?: BookingContainerInput[];
    cutOffDate?: string;
    earlyReturnDate?: string;
    vesselArrivalDate?: string;
    vesselDepartureDate?: string;
    vesselName?: string;
    loadingPortId?: string;
    pickupTerminalId?: string;
    destinationPortId?: string;
    dropoffTerminalId?: string;
    steamshipLine?: string;
    oceanFreight?: string;
    internalNotes?: string;
    externalNotes?: string;
    photoRequirements?: PhotoRequirementInput[];
  }) => {
    const input: Record<string, unknown> & {
      facilityId: string;
      documentNumber: string;
      status: BookingStatus;
      containers: BookingContainerInput[];
    } = {
      facilityId: params.facilityId,
      documentNumber: params.documentNumber,
      status: params.status,
      containers: [],
    };

    // Only add fields if they have values
    if (params.cutOffDate) input.cutOffDate = params.cutOffDate;
    if (params.earlyReturnDate) input.earlyReturnDate = params.earlyReturnDate;
    if (params.vesselArrivalDate)
      input.vesselArrivalDate = params.vesselArrivalDate;
    if (params.vesselDepartureDate)
      input.vesselDepartureDate = params.vesselDepartureDate;
    if (params.vesselName) input.vesselName = params.vesselName;
    if (params.loadingPortId) input.loadingPortId = params.loadingPortId;
    if (params.pickupTerminalId)
      input.pickupTerminalId = params.pickupTerminalId;
    if (params.destinationPortId)
      input.destinationPortId = params.destinationPortId;
    if (params.dropoffTerminalId)
      input.dropoffTerminalId = params.dropoffTerminalId;
    if (params.steamshipLine) input.steamshipLine = params.steamshipLine;
    if (params.oceanFreight) input.oceanFreight = params.oceanFreight;
    if (params.internalNotes) input.internalNotes = params.internalNotes;
    if (params.externalNotes) input.externalNotes = params.externalNotes;
    if (params.photoRequirements)
      input.photoRequirements = params.photoRequirements;

    if (params.containers)
      input.containers = params.containers.filter(
        (container) => container.containerTypeId && container.quantity > 0,
      );

    return {
      tradeBookingCreate: {
        __args: {
          input,
        },
        id: true,
        facilityId: true,
        documentNumber: true,
        status: true,
        cutOffDate: true,
        earlyReturnDate: true,
        vesselArrivalDate: true,
        vesselDepartureDate: true,
        vesselName: true,
        loadingPortId: true,
        loadingPort: {
          id: true,
          unLocode: true,
          name: true,
          countryCode: true,
        },
        pickupTerminalId: true,
        pickupTerminal: {
          id: true,
          terminalCode: true,
          name: true,
        },
        destinationPortId: true,
        destinationPort: {
          id: true,
          unLocode: true,
          name: true,
          countryCode: true,
        },
        dropoffTerminalId: true,
        dropoffTerminal: {
          id: true,
          terminalCode: true,
          name: true,
        },
        steamshipLine: true,
        oceanFreight: true,
        internalNotes: true,
        externalNotes: true,
        containers: {
          containerType: {
            id: true,
            name: true,
          },
          quantity: true,
        },
        photoRequirements: {
          description: true,
          required: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    };
  },
);
